import { Spin, Tooltip } from 'antd';
import React from 'react';
import { CustomerObjectMapType } from "../../../util/providers/CustomerProvider";
import {
  Card,
  Col,
  Row,
} from 'antd';
import { format } from 'date-fns';
import { CheckCircleFilled, QuestionCircleFilled, WarningFilled } from '@ant-design/icons';
import DescriptionItem from './DescriptionItem';
import { CountryLookup } from "../../../util/countries";

export type Props = {
  customer: CustomerObjectMapType|undefined;
};

const PersonalDetails: React.FC<Props> = ({customer}) => {
  if (!customer) return <Spin />

  const {
    email,
    familyName,
    givenName,
    phoneNumber,
    hasCompletedSetup,
    "custom:alpha2": alpha2,
  } = customer;
  const confirmed = customer.userStatus === "CONFIRMED";
  const dateRegistered = format(new Date(customer.userCreateDate), "MMM do yyyy");
  const country = alpha2 ? CountryLookup(alpha2)?.Country : "Unknown";

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <div className="p-4">
        <Row gutter={[16,16]}>
          <Col xs={24} sm={12}>
            <DescriptionItem title="Full Name:" content={`${givenName} ${familyName}`} />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Registration date"
              content={dateRegistered}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem title="Phone number:" content={phoneNumber} />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Email:"
              content= {
                confirmed ?
                (
                  <Tooltip title="Customer has confirmed their E-mail address" className='flex items-center'>
                    <>
                      {email}
                      <CheckCircleFilled
                        style={{
                          color: "LimeGreen",
                          fontSize: "1.25em",
                          marginLeft: 8,
                        }}
                      />
                    </>
                  </Tooltip>
                ) : (
                  <Tooltip title="Customer has not confirmed their E-mail address" className='flex items-center'>
                    <>
                      {email}
                      <QuestionCircleFilled
                        style={{
                          color: "DarkOrange",
                          fontSize: "1.2em",
                          marginLeft: 8,
                        }}
                      />
                    </>
                  </Tooltip>
                )}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem title="Account setup:" content={
              hasCompletedSetup ? (
                <Tooltip title="Customer has setup their iLivestock account" className='flex items-center'>
                  <>
                    Completed
                    <CheckCircleFilled
                      style={{
                        color: "LimeGreen",
                        fontSize: "1.25em",
                        marginLeft: 8,
                      }}
                    />
                  </>
                </Tooltip>
              ) : (
                <Tooltip title="Customer has not setup their iLivestock account" className="flex items-center">
                  <>
                    Incomplete
                    <WarningFilled
                      style={{
                        color: "DarkOrange",
                        fontSize: "1.2em",
                        marginLeft: 8,
                      }}
                    />
                  </>
                </Tooltip>
              )}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Country:"
              content={country}
            />
          </Col>
        </Row>
      </div>
    </Card>
  )
}

export default PersonalDetails;